import { Typography } from '@mui/material';
import { type To } from 'react-router-dom';

import { gql } from '@graphql/__generated__';
import type { TeamInfo_TeamFragment } from '@graphql/__generated__/graphql';
import { ConditionalLinkWrapper } from '@modules/_shared/components/ConditionalLinkWrapper';
import { TeamAvatar } from '@modules/_shared/components/TeamAvatar';

export const TEAM_INFO_TEAM_FRAGMENT = gql(/* GraphQL */ `
  fragment TeamInfo_team on teams {
    id
    name
    logo {
      id
      url
    }
    locality
    state
    postcode
  }
`);

interface TeamInfoProps {
  team: TeamInfo_TeamFragment;
  enableLink?: boolean;
  to?: To;
}

export const TeamInfo = (props: TeamInfoProps) => {
  const { enableLink = false, team, to } = props;

  if (team == null) {
    console.error('Only teams should be passed to TeamInfo');
    return null;
  }

  const { id, logo, name, postcode, locality, state } = team;

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'max-content 1fr',
        alignItems: 'center',
        gap: 8,
        height: '100%',
        lineHeight: 'normal',
      }}
    >
      <ConditionalLinkWrapper
        link={
          enableLink
            ? {
                to: to ? to : `/teams/${id}`,
              }
            : undefined
        }
      >
        <TeamAvatar logoUrl={logo?.url} />
        <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
          <Typography variant="body2" noWrap>
            {name}
          </Typography>
          <Typography
            component="p"
            variant="caption"
            noWrap
            sx={{
              color: 'text.secondary',
              marginBottom: 0,
            }}
          >
            {postcode} {locality}, {state}
          </Typography>
        </div>
      </ConditionalLinkWrapper>
    </div>
  );
};
